<template>
  <div id="app">
  <!--<v-touch id="app" v-on:swipeleft="onSwipeLeft" @swiperight="onSwipeRight">-->
    <app-header></app-header>
    <transition
      @enter="enter"
      @leave="leave"
      :css="false"
      mode="out-in">
      <router-view/>
    </transition>
  <!--</v-touch>-->
  </div>
</template>

<script>

  import {db, firebaseApp} from '@/utils/firebase'
  import AppHeader from '@/components/AppHeader'
  import {TweenLite, Circ} from 'gsap'

  export default {
    name: 'App',
    components: {
      AppHeader
    },
    data () {
      return {
        fromLeft: true,
        deepLink: true
      }
    },
    created () {
      firebaseApp.auth().onAuthStateChanged((user) => {
        if (!user) return false
        db.ref('users/' + user.uid).once('value').then((snapshot) => {
          this.$store.commit('SET_USER', snapshot.val())
        })
      })
    },
    methods: {
      onSwipeLeft () {
        if (this.$route.path === '/') {
          this.$router.replace('/new-game')
        } else if (this.$route.path === '/new-game') {
          this.$router.replace('/history')
        }
      },
      onSwipeRight () {
        if (this.$route.path === '/new-game') {
          this.$router.replace('/')
        } else if (this.$route.path === '/history') {
          this.$router.replace('/new-game')
        }
      },
      enter (el, done) {
        if (this.deepLink) {
          TweenLite.from(el, 0.3, {
            autoAlpha: 0,
            ease: Circ.easeOut,
            onComplete: done
          })
        } else {
          TweenLite.from(el, 0.3, {
            x: this.fromLeft ? '-100%' : '100%',
            ease: Circ.easeOut,
            onComplete: done
          })
        }
      },
      leave (el, done) {
        TweenLite.to(el, 0.3, {
          x: this.fromLeft ? '100%' : '-100%',
          ease: Circ.easeOut,
          onComplete: done
        })
      }
    },
    watch: {
      '$route' (to, from) {
        if (from.name !== null) {
          this.deepLink = false
        }
        this.fromLeft = to.path === '/' || from.path === '/history' && to.path === '/new-game'
      }
    }
  }

</script>

<style lang="scss">

  @import './assets/css/main';

</style>



// WEBPACK FOOTER //
// src/App.vue